export const getUrlWithoutQueryParams = () => {
  if (typeof window !== `undefined`) {
    return window.location.href.split('?')[0];
  }
  return '';
};
